/*
 * The current theme loads the main JS files from all three themes separately.
 *
 * If you wish to override functionality from either Watea or Starter, you will
 * have to remove the reference to the desired javascript files in ./templates/Page.ss
 * and reimplement (or copy over) any removed functionality
 */

import accessibleIframes from './components/accessibleIframes';
import { mainNavCollapse } from './components/bootstrap-events';
import equalise from './components/equalise';
import fontSizeTool from './components/font-size-tool';
import homeBanner from './components/home-banner';
import { mainNavHeight } from './components/navigation';
import scrollProperties from './components/scroll-properties';

const remFactor = localStorage.getItem('remFactor') ?? 16;

mainNavCollapse();
fontSizeTool();
mainNavHeight(remFactor);
scrollProperties();
homeBanner(null, remFactor);
accessibleIframes();

window.addEventListener('load', () => {
  equalise();
  equalise(
    '[class*=dynamic__elements__features__elements__elementfeatures]',
    'md-down'
  );
});
